import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

import { AdminLineChartModule, DateRangeModalModule, FrequencyRatioModule, LineChartModule } from '@sociuu/shared';
import { NgApexchartsModule } from 'ng-apexcharts';
import { StatisticsModule } from '@sociuu/sharedStatistics';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { TopPerformingGroupsModule } from './top-performing-groups/top-performing-groups.module';
import { MessageNotificationCenterModule } from './message-notification-center/message-notification-center.module';
import { CustomDateSelectWrapperModule } from '@app/shared/custom-date-select-wrapper/custom-date-select-wrapper.module';

import { DashboardComponent } from './dashboard.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,

    MatDialogModule,
    MatSelectModule,
    MatFormFieldModule,

    LineChartModule,
    StatisticsModule,
    NgApexchartsModule,
    DateRangeModalModule,
    FrequencyRatioModule,
    AdminLineChartModule,
    DashboardRoutingModule,
    TopPerformingGroupsModule,
    CustomDateSelectWrapperModule,
    MessageNotificationCenterModule,
  ],
})
export class DashboardModule {}
